import {request} from '@/helpers/apiClient'
import {ORDER_CONFIG} from '@/utils/constants/apiConfig/orderApiConfig'

export const getItemOverviewDetails = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW)

export const getSubItemColConfig = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_SUBITEM_COL_CONFIG)

export const getGeneralDetails = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_GENERAL_DETAILS)

export const getDeliveryAndStatusInfo = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_DELIVERY_STATUS_INFO)

export const getFulfillment = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_FULFILLMENT)

export const getAdjustment = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_ADJUSTMENT)

export const getTaxesInformation = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_TAXES_INFORMATION)

export const getItemDiscount = () => request(ORDER_CONFIG.ORDER_ITEM_OVERVIEW_ITEM_DISCOUNT)
